function formatPhone(phone) {
    const areaCode = '972';
    const value = String(phone);
    return value.startsWith(areaCode) ? `0${value.substring(areaCode.length)}` : value;
}

export default formatPhone;
